const pushEventDataLayer = (event, category, action, label, location = '') => {
  pushEventDataLayerObj({
    event,
    category,
    action,
    label,
    location,
  })
}

export const pushEventData = incommingObject => {
  pushEventDataLayerObj(
    Object.assign(
      {
        event: 'Interacciones',
        category: 'universo-cole',
        action: 'click',
        label: '',
        location: 'www.nosotrasonline.com.co/universo-cole',
      },
      incommingObject
    )
  )
}

export const pushEventDataLayerObj = dataObj => {
  try {
    // trackEvent

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(dataObj)

    if (
      process.env.ENVIRONMENT === 'LOCAL' ||
      process.env.ENVIRONMENT === 'DEV'
    ) {
      console.log('=============PUSH  DATALAYER')
      console.log(dataObj)
      console.log('=============PUSH  DATALAYER')
    }
  } catch (e) {
    console.log('Datalayer Error')
  }
}
export default pushEventDataLayer
